
export function getCitation(data) {
    // Monografia
    // TODO: Monografia - pocet stran ako celok nie ako od - do
    if (data.citation_type == 1) {
        // console.log(data);
        let author = ''
        if (data.single_author) {
            let work = data.authors[0];
            work = work.split(' ');
            if (work.length == 2) {
                author = `${work[1].toUpperCase()}, ${work[0]} et al.`;
            } else {
                // TODO: Handle author having more than one name
            }
        } else {
            if (data.authors.length == 1) {

                let work = data.authors[0];
                work = work.split(' ');
                if (work.length == 2) {
                    author = `${work[1].toUpperCase()}, ${work[0]}`;
                } else {
                    // TODO: Handle author having more than one name
                }

            } else if (data.authors.length == 2) {
                let auth1 = data.authors[0];
                let auth2 = data.authors[1];
                auth1 = auth1.split(' ');
                auth2 = auth2.split(' ');
                if (auth1.length == 2 && auth2.length == 2) {
                    author = `${auth1[1].toUpperCase()}, ${auth1[0]} - ${auth2[1].toUpperCase()}, ${auth2[0]}`;
                } else {
                    // TODO: Handle author having more than one name
                }

            }
            else if (data.authors.length == 3) {
                let auth1 = data.authors[0];
                let auth2 = data.authors[1];
                let auth3 = data.authors[2];
                auth1 = auth1.split(' ');
                auth2 = auth2.split(' ');
                auth3 = auth3.split(' ');
                if (auth1.length == 2 && auth2.length == 2 && auth3.length == 2) {
                    author = `${auth1[1].toUpperCase()}, ${auth1[0]} - ${auth2[1].toUpperCase()}, ${auth2[0]} - ${auth3[1].toUpperCase()}, ${auth3[0]}`;
                } else {
                    // TODO: Handle author having more than one name
                }
            }
            else if (data.authors.length > 3) {
                let work = data.authors[0];
                work = work.split(' ');
                if (work.length == 2) {
                    author = `${work[1].toUpperCase()}, ${work[0]} et al`;
                } else {
                    // TODO: Handle author having more than one name
                }
            }
        }


        const template = `<p>${author}. <i>${data.title}</i>. ${data.city} : ${data.publisher}, ${data.year}, ${data.total_pages ? data.total_pages : data.full_pages} s. ${data.isbn}.</p>`;
        return template;
    } else if (data.citation_type == 2) {
        // Zbornik type primarna zodpovednost
        // BYSTRICKÝ, Valerián (ed.). Slovensko v politickom systéme Československa : Materiály z vedeckého sympózia Častá 11. – 13. novembra 1991. Bratislava : Historický ústav SAV, 1992, 99 s.
        // Author (ed). Title Conference City Publisher, year, pages ISBN
        let author = '';
        let work = data.authors[0];
        work = work.split(' ');
        if (work.length == 2) {
            author = `${work[1].toUpperCase()}, ${work[0]}`;
        } else {
            // TODO: Handle author having more than one name
        }

        const template = `<p>${author} (ed.). <i>${data.title}</i>. ${data.city} : ${data.publisher}, ${data.year}, ${data.total_pages ? data.total_pages : data.full_pages} s. ${data.isbn}.</p>`;
        return template;
    } else if (data.citation_type == 3) {
        // Zbornik type sekundarna zodpovednost
        // Slovenská veda : Zborník zo 14. medzinárodnej konferencie. Ed. Elena Nedorostová. Bratislava : Veda, 2001, 248 s.
        let work = data.authors[0];
        work = work.split(' ');
        let author;
        if (work.length == 2) {
            author = `${work[1].toUpperCase()}, ${work[0]}`;
        } else {
            // TODO: Handle author having more than one name
        }
        const template = `<p><i>${data.title}</i>. Ed. ${author}. ${data.city} : ${data.publisher}, ${data.year}, ${data.total_pages ? data.total_pages : data.full_pages} s. ${data.isbn}.</p>`;
        return template;
    } else if (data.citation_type == 4) {
        // Study
        // MICHÁLEK, Slavomír. Hodža a Osuský, názory a pozície v rokoch 1939 – 1945. In PEKNÍK, Miroslav (ed.). Milan Hodža štátnik a politik. Bratislava : Veda, 2002, s. 301-317. ISBN 978-80-224-0690-1.
        let work = data.authors[0];
        work = work.split(' ');
        let author;

        if (work.length == 2) {
            author = `${work[1].toUpperCase()}, ${work[0]}`;
        } else {
            // TODO: Handle author having more than one name
        }

        const template = `<p>${author}. ${data.title}. In ${data.parent_author} <i>${data.parent_article}</i>. ${data.city} : ${data.publisher}, ${data.year}, s. ${data.pageFrom}-${data.pageTo}. ISBN ${data.isbn}.</p>`;
        return template;
    } else if (data.citation_type == 5) {
        // Periodical
        // KOVÁČ, Dušan. Popoluška slovenskej historiografie – vlastné dejiny. In Historický časopis, 2004, roč. 52, č. 2, s. 233-244.
        let work = data.authors[0];
        work = work.split(' ');
        let author;

        if (work.length == 2) {
            author = `${work[1].toUpperCase()}, ${work[0]}`;
        } else {
            // TODO: Handle author having more than one name
        }
        return `<p>${author}, ${data.title}. In <i>${data.publisher}</i>, ${data.year}, roč. ${data.vol}, č. ${data.num}, s. ${data.pageFrom}-${data.pageTo}. ${data.isbn}.</p>`;
    } else if (data.citation_type == 6) {
        // Internet
        // KUCIANOVÁ, Anna. Personálie v elektronickej súbežnej Slovenskej národnej bibliografii. In Bibliografický zborník 2000 – 2001. [online]. Martin : Slovenská národná knižnica, 2005, s. 136-139. [cit. 2016-12-23]. URL: <http://www.snk.sk/nbuu/Zborník_2000_2001.pdf>
        let work = data.authors[0];
        work = work.split(' ');
        let author;

        if (work.length == 2) {
            author = `${work[1].toUpperCase()}, ${work[0]}`;
        } else {
            // TODO: Handle author having more than one name
        }

        if (data.city && data.publisher_online && data.pageFrom && data.pageTo) {
            return `<p>${author}. ${data.title}. In <i>${data.publisher}</i>. [online]. ${data.city} : ${data.publisher_online}, ${data.year}, s. ${data.pageFrom}-${data.pageTo}. [cit. ${new Date().toISOString().slice(0, 10)}]. URL: <${data.url}></p>`;
        } else {
            return `<p>${author}. ${data.title}. In <i>${data.publisher}</i>. [online]. [cit. ${new Date().toISOString().slice(0, 10)}]. URL: <${data.url}></p>`;
        }
    } else if (data.citation_type == 7) {
        // Slovenský národný archív (ďalej SNA), fond (ďalej f.) Povereníctvo informácií a osvety (ďalej PIO), škatuľa (ďalej š.) 9, č. 785.
        const template = `<p>${data.archive}, fond <i>${data.trust}</i>, škatuľa ${data.crate}, ${data.doc_number}</p>`;
        return template;
    }
}